module.exports = __webpack_public_path__ + "static/media/1-square-dirty.ef58de3c.svg";